// extracted by mini-css-extract-plugin
module.exports = {"noteCon":"addNotes_noteCon__3kqhW","textBox":"addNotes_textBox__1RpPZ","btnSubmit":"addNotes_btnSubmit__1OGUv"};